import { GutBodyConnectionsOrganList } from '@repo/ui';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useGutBodyProps from 'hooks/useGutBodyProps';
import useSelectOrgan from 'hooks/useSelectOrgan';
import useOrgans from 'services/organs/useOrgans';
import styles from './OrganList.module.css';

/**
 * The tappable half of the card, below the breakpoint where the map goes inert.
 * Its divider separates it from the body above.
 */
export default function OrganList() {
  const { currentKit } = useCurrentKitAndTinyAccount();
  const { organs } = useOrgans(currentKit?.id);
  const selectOrgan = useSelectOrgan('home_card');
  const { age, pregnant, sex, colorVariant } = useGutBodyProps();

  return (
    <div className={styles.container}>
      <GutBodyConnectionsOrganList
        organs={organs}
        age={age}
        pregnant={pregnant}
        sex={sex}
        colorVariant={colorVariant}
        onOrganSelect={selectOrgan}
      />
    </div>
  );
}
